import { translate } from "../lib/intl";

export function register_translate(Survey) {
  // Function doesn't seem to act properly
  Survey.FunctionFactory.Instance.register("translateDate", (p) => {
    return translate("general.date", { date_in: p[1] });
  });
}
